import React from 'react'
import useAuthenticationStore, { AuthenticationViews } from './Store'
import LocalizedText from '../presentational/LocalizedText'
import useTranslate from '../../hooks/useTranslate';
import LanguageSwitcher from './LanguageSwitcher';
import { getOperatingSystem } from './utils';
import './LoginFooter.css';

const LoginFooter: React.FC = () => {
  const { state } = useAuthenticationStore()
  const { activeView } = state;
  const translations = useTranslate(["participant-login-footer-product-logo", "participant-login-footer-product-link", "participant-login-footer-product-name", "participant-login-privacy-policy-link"])
  const downloadTranslations = useTranslate(["download-app-iphone-icon", "download-app-iphone-link", "download-app-google-icon", "download-app-google-link"])

  var mobileOS = getOperatingSystem();
  var downloadIcon = mobileOS === "iOS" ? downloadTranslations["download-app-iphone-icon"] : downloadTranslations["download-app-google-icon"];
  var downloadLink = mobileOS === "iOS" ? downloadTranslations["download-app-iphone-link"] : downloadTranslations["download-app-google-link"];
  const showDownloadWrapper = !state.project && (mobileOS == "iOS" || mobileOS == "Android") && downloadLink && downloadIcon;

  return (
    <footer className={`authentication-footer ${showDownloadWrapper ? "download-wrapper-show" : ""} ${[AuthenticationViews.setPassword, AuthenticationViews.verifyPhone, AuthenticationViews.loginPassword].includes(activeView!) ? 'mobile-hide' : ''}`}>
      <div className="footer-content">
        <div className="footer-logo">
          <a href={translations["participant-login-footer-product-link"]} target="_blank">
            <img src={translations["participant-login-footer-product-logo"]} alt={translations["participant-login-footer-product-name"]} />
          </a>
        </div>
        <div className="footer-small-print">
          <span>©{(new Date().getFullYear())}</span>
          <span><LocalizedText textKey="participant-login-all-rights-reserved" /></span>
          <span dangerouslySetInnerHTML={{ __html: translations["participant-login-privacy-policy-link"] }} />
        </div>
        <LanguageSwitcher />
      </div>
      {
        showDownloadWrapper && (
          <div className="download-wrapper">
            <a className="download-link" href={downloadLink}>
              <img
                className="download-icon"
                src={downloadIcon}
                alt="Download MyDataHelps"
              />
            </a>
          </div>
        )
      }
    </footer>
  )
}

export default LoginFooter